/* assets/ba-cart-remove.js
   WHAT: Makes the cart's Remove link resolve its line against the LIVE cart at click time
         instead of trusting the key the page was rendered with.
   WHY:  The Gift Box (Digismoothie) GWP app re-syncs whenever the cart changes, and it
         RECREATES lines rather than leaving them alone - which gives them new keys. A key
         printed into the page is therefore a snapshot, and `/cart/change?id=<stale key>`
         matches nothing and silently does nothing.

         Measured on the live Venture copy (theme 131640557701) on 2026-10-13: after switching
         from line-index to line-key addressing, X4i and X6 removed cleanly but Pump X still
         could not be removed - its gifts had been recreated between render and click. Resolving
         at click time fixed it, and all removal cases then passed.

         The link's href is left untouched, so with JavaScript unavailable the ordinary
         navigation still removes the line. This only makes it accurate.
   WHEN: 2026-10-13. Ported from the fix proven on the live Venture copy.
*/
(function () {
  'use strict';

  document.addEventListener('click', function (ev) {
    var link = ev.target.closest && ev.target.closest('a.ba-cart-remove');
    if (!link) return;
    ev.preventDefault();

    var key = link.getAttribute('data-key');
    var variant = link.getAttribute('data-variant');
    link.style.pointerEvents = 'none';

    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { line = cart.items[i]; break; }
        }
        // The key moved. Fall back to the variant, which does not change when a line is recreated.
        if (!line && variant) {
          for (var j = 0; j < cart.items.length; j++) {
            if (String(cart.items[j].variant_id) === String(variant)) { line = cart.items[j]; break; }
          }
        }
        if (!line) { window.location.href = link.getAttribute('href'); return; }

        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function () {
          // The gift app reacts to the change asynchronously; let it settle, then show the
          // true cart rather than a state it is about to alter under the customer.
          setTimeout(function () { window.location.href = window.location.pathname; }, 900);
        });
      })
      .catch(function () { window.location.href = link.getAttribute('href'); });
  }, false);

  /* ---------- Resync when the rendered rows fall behind the real cart ----------
     Ported from the live Venture fix 2026-10-19. Measured on this draft the same day: /cart.js
     held 4 lines while the page had rendered 3, because the gift app granted the Mic-X after
     the page was drawn. That is the same fault customers reported on live as "it says 3 items
     in cart it is only showing 2".

     Acts on a MISMATCH rather than waiting for the cart to go quiet - an earlier version waited
     for two identical reads with a 10s ceiling and simply settled on the pre-gift state when the
     app took 15s. Compares every 1.5s for up to 30s and reloads once, guarded by a URL flag so
     it can never loop. Build rule 5: a URL flag, not storage. */
  var FLAG = 'ba_rs';

  function renderedRowCount() {
    return document.querySelectorAll('.cart__item[data-key]').length;
  }

  function watchCartPage() {
    var started = Date.now(), acted = false;
    (function poll() {
      if (acted || Date.now() - started > 30000) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var shown = renderedRowCount();
          if (shown > 0 && shown !== cart.items.length) {
            acted = true;
            window.location.replace(window.location.pathname + '?' + FLAG + '=1');
            return;
          }
          setTimeout(poll, 1500);
        })
        .catch(function () { setTimeout(poll, 1500); });
    })();
  }

  function start() {
    if (/\/cart/.test(window.location.pathname) && window.location.search.indexOf(FLAG) === -1) {
      watchCartPage();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
